import { Box, Flex } from '@chakra-ui/react';
import { Switch } from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import {
  setReviewCreationCalibrationAndDeliverables,
  setReviewCreationOutcomeQuestion,
  useSelectReviewCreationCalibrationAndDeliverables,
} from 'reducers/reviewCreationV1Slice';
import { AnswerTypes } from 'screens/admin/Reviews/ReviewProcessV1/Steps/Calibration/ScoreSection';

import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { OutcomeSettingTable } from './OutcomeSettingTable';

const defaultTextAnswerOptions = [
  { description: 'Promote', score: 1, displayOrder: 1 },
  { description: 'No Change', score: 2, displayOrder: 2 },
  { description: 'PIP', score: 3, displayOrder: 3 },
  { description: 'Promote in Future', score: 4, displayOrder: 4 },
];

const OutcomeScore = () => {
  const { outcomeQuestion, isOutcomeQuestionDisabled } = useSelectReviewCreationCalibrationAndDeliverables();
  const { answerOptions = [] } = outcomeQuestion ?? {};
  const dispatch = useDispatch();
  const handleOutcomeChange = (newAnswerOptions) => {
    dispatch(setReviewCreationOutcomeQuestion({ answerOptions: newAnswerOptions }));
  };

  const onOutcomeQuestionDisabledChange = (value: boolean) => {
    // if user is enabling the outcome questions and there are no answer options, add the default answer options
    if (value && (answerOptions?.length === 0 || !answerOptions)) {
      dispatch(
        setReviewCreationOutcomeQuestion({
          answerOptions: defaultTextAnswerOptions,
          answerType: AnswerTypes.DROP_DOWN,
        })
      );
    }
    dispatch(setReviewCreationCalibrationAndDeliverables({ isOutcomeQuestionDisabled: !value }));
  };

  return (
    <Flex borderRadius="8px" flexDir="column" border="4px solid #E7EBEF" bg="white">
      <Flex flexDir="column" py={2} px={3}>
        <Flex
          flexDir="column"
          pb={4}
          borderBottom="1px solid"
          borderColor={isOutcomeQuestionDisabled ? 'transparent' : 'border.CFD7DF'}
        >
          <TextBodyMedium bold>Outcome</TextBodyMedium>
          <Flex justifyContent="space-between" alignItems="center">
            <TextLabel color="text.g2">
              Outcome provides a conclusive summary of the review, combining final ratings with decisions such as
              promotion, future growth opportunities, or performance improvement plans (PIP).
            </TextLabel>
            <Switch checked={!isOutcomeQuestionDisabled} onCheckedChange={onOutcomeQuestionDisabledChange} />
          </Flex>
        </Flex>
      </Flex>
      {!isOutcomeQuestionDisabled && (
        <Box py={2} px={3}>
          <Flex alignItems="center">
            <TextBodyMedium mr={2}>Define the outcomes:</TextBodyMedium>
            <TooltipInfoV1 title="Assign labels to outcomes as needed for this review." />
          </Flex>
          <OutcomeSettingTable scoreSetting={answerOptions} onChange={handleOutcomeChange} />
        </Box>
      )}
    </Flex>
  );
};

export { OutcomeScore };
